export default __webpack_public_path__ + "static/media/team-red.fd20deaa.gif";